import styled from 'styled-components';

import { ButtonGnb } from '../style';

export const ButtonLogin = styled(ButtonGnb)`
  flex: 0 0 24px;
`;
